import { plural, singular } from "pluralize";

export const pluralizeWord = (word: string) => {
  return plural(word);
};

export const singularizeWord = (word: string) => {
  return singular(word);
};
